import calendar from "@/converters/calendar";
import categories from "@/converters/categories";
import coreNews from "@/converters/coreNews";
import departments from "@/converters/departments";
import externalDepartments from "@/converters/externalDepartments";
import externalGroups from "@/converters/externalGroups";
import groups from "@/converters/groups";
import mealDishes from "@/converters/mealDishes";
import medias from "@/converters/medias";
import meetingAgendaPoints from "@/converters/meetingAgendaPoints";
import people from "@/converters/people";
import pictograms from "@/converters/pictograms";
import plannerCategories from "@/converters/plannerCategories";
import plannerFilters from "@/converters/plannerFilters";
import shared from "@/converters/shared";
import workSchedule from "@/converters/workSchedule";

export default {
  calendar,
  categories,
  coreNews,
  departments,
  externalDepartments,
  externalGroups,
  groups,
  mealDishes,
  medias,
  meetingAgendaPoints,
  people,
  pictograms,
  plannerCategories,
  plannerFilters,
  shared,
  workSchedule,
};
